<script>
import dynamicFieldsService from '@/services/DynamicFields/dynamicFieldsService';
import {vueTopprogress} from 'vue-top-progress';
import logsService from '@/services/Logs/logsService';

import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

Vue.component('v-select', vSelect);

export default {
  data() {
    return {
      dynamicField: {},
      templates: [],

      cadastros: [
        'financing',
      ],

      tipoCampos: [
        'currency',
        'date',
        'string',
        'number',
      ],

      Deselect: {
        render: (createElement) => createElement('span', '❌'),
      },

      modalidade: process.env.VUE_APP_TYPE,
      submodalidade: process.env.VUE_APP_SUBTYPE
    };
  },
  computed: {
    currentPessoa() {
      return this.$store.getters.getPessoa;
    }
  },
  mounted() {
    if ( this.modalidade == 'equity' ) {
      if ( this.submodalidade == 'bacen' ) {
        this.templates = ['bacen'];
      }
      else {
        this.templates = ['equity', 'debt'];
      }
    }
    else {
      this.templates = ['Doação'];
    }
  },
  components: {
    vueTopprogress,
  },
  methods: {
    async addNew() {
      this.$refs.topProgress.start();

      try {
        const logUser = {
          user: {
              email: this.currentPessoa.email.email
          }
        };
        const logContent = this.dynamicField;
        logsService.createNewLog(logUser, '', 'Adicionar Campo Dinâmico', '', logContent);

        await dynamicFieldsService.create(this.dynamicField);

        this.$refs.topProgress.done();

        this.$router.push('dynamic-fields');

        this.$notify({
          title: 'Campo dinâmico criado com sucesso!',
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'success',
          timeout: 3000,
        });
      } catch (error) {
        this.$notify({
          title: 'Ooopss',
          message: 'Desculpe, ocorreu um erro. Tente novamente.',
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });
      }

      this.dynamicField = {};
    },

    checkAcceptTerms() {
       this.$refs.accept_term.click();
    },

    checkIsPublic() {
      this.$refs.is_public.click();
    },
  },
};
</script>

<template>
  <div class="add-user">
    <card>
      <form @submit.prevent="addNew()">
        <h5 slot="header" class="title">
          <router-link to="/dynamic-fields" class="fa fa-arrow-left"></router-link>
          Criar Campo Dinâmico
        </h5>

        <div class="row">
            <div class="col-md-4 pl-md-1">
              <base-input required label="Template*">
                <v-select
                  label="name"
                  class="style-chooser"
                  :options="templates"
                  v-model="dynamicField.template"
                  :components="{ Deselect }"
                ></v-select>
              </base-input>
            </div>

            <div class="col-md-4 pr-md-1 mb-2">
              <base-input required label="Cadastro*">
                <v-select
                  label="name"
                  class="style-chooser"
                  :options="cadastros"
                  v-model="dynamicField.crud"
                  :components="{ Deselect }"
                ></v-select>
              </base-input>
            </div>

            <div class="col-md-4 pl-md-1">
              <base-input required label="Tipo do campo*">
                <v-select
                  label="name"
                  class="style-chooser"
                  :options="tipoCampos"
                  v-model="dynamicField.type"
                  :components="{ Deselect }"
                ></v-select>
              </base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 pl-md-1">
                <base-input
                label="Label*"
                placeholder="Informe o label do campo"
                v-model="dynamicField.label"
                required
                >
                </base-input>
            </div>

            <div class="col-md-4 pl-md-1">
                <base-input
                label="Placeholder*"
                placeholder="Informe o placeholder do campo"
                v-model="dynamicField.placeholder"
                required
                >
                </base-input>
            </div>

            <div class="col-md-4 pl-md-1">
                <base-input
                label="Referência*"
                placeholder="Informe a referência do campo"
                v-model="dynamicField.reference"
                required
                >
                </base-input>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4 pl-md-1">
                <base-input
                label="Ordenação*"
                placeholder="Informe a ordem em que o campo deve aparecer"
                v-model="dynamicField.ordenacao"
                v-mask="'###'"
                required
                >
                </base-input>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2 pl-md-1">
                <input name="accept_term" ref="accept_term" type="checkbox" v-model="dynamicField.required"/>
                <label for="accept_term" style="margin-left: 5px;" @click="checkAcceptTerms"> Campo obrigatório</label>
            </div>

            <div class="col-md-2 pl-md-1">
                <input name="is_public" ref="is_public" type="checkbox" v-model="dynamicField.is_public"/>
                <label for="is_public" style="margin-left: 5px;" @click="checkIsPublic"> Campo público</label>
            </div>

        </div>

        <button type="submit" class="btn btn-sm">Adicionar</button>
      </form>
    </card>

    <vue-topprogress ref="topProgress"></vue-topprogress>
  </div>
</template>
